import React, { useState, useEffect } from 'react';
import { siteAPI } from '../lib/api';
import { Wrench } from 'lucide-react';

const MaintenancePage = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await siteAPI.getStatus();
        setMessage(res.data.maintenance_message || '');
      } catch { /* ignore */ }
    };
    fetchStatus();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 mx-auto bg-[#FEF7E0] rounded-full flex items-center justify-center mb-6">
          <Wrench className="w-12 h-12 text-[#F9AB00]" />
        </div>
        <h1 className="text-3xl font-semibold text-[#202124] mb-4" style={{ fontFamily: 'Outfit' }}>
          Under Maintenance
        </h1>
        <p className="text-lg text-[#5F6368] mb-6">
          {message || 'We are currently performing maintenance. Please check back shortly.'}
        </p>
        <div className="w-48 h-1 bg-[#DADCE0] rounded-full mx-auto overflow-hidden">
          <div className="h-full bg-[#F9AB00] rounded-full animate-pulse w-1/2" />
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
